import React, { useEffect, useRef, useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

// import { useNavigate } from 'react-router-dom';
import { ReactComponent as Brightness } from '../../assets/icons/brightness.svg';
import { ReactComponent as Close } from '../../assets/icons/close-circle-red.svg';
import { ReactComponent as Darkness } from '../../assets/icons/darkness.svg';
// import { ReactComponent as Desktop } from '../../assets/icons/desktop.svg';
import { ReactComponent as Downarrow } from '../../assets/icons/down-arrow.svg';
// import { ReactComponent as Downarrow } from '../../assets/icons/down-arrow.svg';
import { ReactComponent as ProfileEdit } from '../../assets/icons/edit-v2.svg';
import { ReactComponent as Notification } from '../../assets/icons/notification.svg';
import { ReactComponent as Tick } from '../../assets/icons/tick-icon.svg';
import { ReactComponent as TrendUp } from '../../assets/icons/trend-up.svg';
import { ReactComponent as UploadIcon } from '../../assets/icons/upload-icon.svg';
import profile from '../../assets/images/profiles/profile.jpg';
// import { brandImage } from '../../config/branding';
import { brandIcons } from '../../config/branding';
import { PortalType } from '../../config/enum';
import LanguageSelector from '../../contexts/language-selector/LanguageSelector';
// import { CustomDashboard } from '../../interface/dashboard.interface';
import { usePortal } from '../../contexts/PortalContext/PortalContext';
import ThemeContext from '../../contexts/theme-context/ThemeContext';
import { FilterFacilityTagInterFace } from '../../interface/partner-interfaces/facility-tag.interface';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { setSelectedDashboardId } from '../../redux/slices/CustomDashboardSlice';
// import { updateChargerType } from '../../redux/slices/ChargerTypeSlice';
// import ToggleWithIcons from '../toggle-with-icons/ToggleWithIcons';
import { setNotificationMessage } from '../../redux/slices/NotificationManagementSlice';
import {
  changeSelectedCurrentFacilityTag,
  fetchCurrentFacilityTagsList,
} from '../../redux/slices/Partners/FacilityTagSlice';
import { fetchSessionUser } from '../../redux/slices/UsersManagementSlice';
import { decodeJWT } from '../../shared-functions/JWTDocodeFunction';
import { getLocalStorageItem } from '../../shared-functions/LocalStorage';
import dashboardApi from '../../utils/api/dashboard';
import MyButton from '../button/Button';
import CustomInput from '../custom-input/CustomInput';
import ModalBox from '../modal-box/ModalBox';
import ResetPasswordModal from '../reset-password-modal/ResetPasswordModal';
import SuccessNotification from '../success-notification/SuccessNotification';
import TabToggle from '../tab-toggle/TabToggle';
import TimeZoneSelector from '../time-zone-selector/TimeZoneSelector';

/**
 * Header function component
 */
function Header() {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation('sharedComponent');
  const { t: translateProfile } = useTranslation('profile');
  const { theme, setTheme } = useContext(ThemeContext);
  const dashboard = window.location.pathname.includes('ev-admin/dashboard');
  const notification: boolean = false;
  // const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { dashboards, defaultDashboard, selectedDashboardId } = useAppSelector(
    (state) => state.customDashboard,
  );
  const { currentFacilityTagsList } = useAppSelector((state) => state.partnersFacilityTags);
  const [dropdownFacilityOpen, setDropdownFacilityOpen] = useState(false);
  const { sessionUser } = useAppSelector((state) => state.partnerUsers);
  const [cpoUserData, setCpoUserData] = useState<any>(null);

  const { portalType } = usePortal();
  const reference = useRef<HTMLDivElement>(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [resetPasswordModalOpen, setResetPasswordModalOpen] = useState(false);
  const [dropdownNotification, setDropdownNotification] = useState(false);
  // const [chartToggle, setChartToggle] = useState([
  //   {
  //     label: 'personal',
  //     key: 'personal',
  //     isActive: true,
  //   },
  //   {
  //     label: 'commercial',
  //     key: 'commercial',
  //     isActive: false,
  //   },
  // ]);

  /**
   * On dropdown facility click
   */
  const dropDownFacility = () => {
    setDropdownFacilityOpen(!dropdownFacilityOpen);
  };
  /**
   * Filter by facility
   * @param {any} filterData filter data interface
   */
  const filterByFacility = (filterData: FilterFacilityTagInterFace) => {
    dispatch(changeSelectedCurrentFacilityTag(filterData));
    setDropdownFacilityOpen(false);
  };
  /**
   * On dropdown click
   */
  const dropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  /**
   * Opens the reset-password dialog from the super-admin dropdown.
   * @returns {void}
   */
  const handleOpenResetPassword = (): void => {
    setDropdownOpen(false);
    setResetPasswordModalOpen(true);
  };

  /**
   * Closes the reset-password dialog.
   * @returns {void}
   */
  const handleCloseResetPassword = (): void => {
    setResetPasswordModalOpen(false);
  };

  const { title, count, icon } = useAppSelector((state: any) => state.pageTitle);

  const [isProfileImageModalOpen, setIsProfileImageModalOpen] = useState(false);
  const [isProfileImageSuccessModalOpen, setIsProfileImageSuccessModalOpen] = useState(false);
  const [profileImageFile, setProfileImageFile] = useState<File | null>(null);
  const [profileImagePreviewUrl, setProfileImagePreviewUrl] = useState<string | null>(null);
  const [superAdminProfileImage, setSuperAdminProfileImage] = useState<string | null>(null);
  const [isUploadingProfileImage, setIsUploadingProfileImage] = useState(false);

  // TODO: replace with real API response once the super admin summary endpoint is ready
  const [superAdminProfileSummary, setSuperAdminProfileSummary] = useState({
    totalPartners: 0,
    totalStations: 0,
    totalDevices: 0,
    email: '',
    phone: '',
  });
  const [editSuperAdminEmail, setEditSuperAdminEmail] = useState(false);
  const [editSuperAdminPhone, setEditSuperAdminPhone] = useState(false);
  const [superAdminEmailInput, setSuperAdminEmailInput] = useState('');
  const [superAdminPhoneInput, setSuperAdminPhoneInput] = useState('');

  /**
   * Toggle edit mode for the super admin email field, seeding the input with the current value
   */
  const toggleSuperAdminEmailEdit = () => {
    setSuperAdminEmailInput(superAdminProfileSummary.email);
    setEditSuperAdminEmail(!editSuperAdminEmail);
  };

  /**
   * Toggle edit mode for the super admin phone field, seeding the input with the current value
   */
  const toggleSuperAdminPhoneEdit = () => {
    setSuperAdminPhoneInput(superAdminProfileSummary.phone);
    setEditSuperAdminPhone(!editSuperAdminPhone);
  };

  /**
   * Handle changes to the super admin contact edit inputs
   * @param {string} name - The field name ('email' or 'phone')
   * @param {string | number} value - The new field value
   */
  const handleSuperAdminContactInputChange = (name: string, value: string | number) => {
    if (name === 'email') setSuperAdminEmailInput(String(value));
    if (name === 'phone') setSuperAdminPhoneInput(String(value));
  };

  /**
   * Save the edited super admin email
   * TODO: call the real update-profile API once available; currently updates local state only
   */
  const saveSuperAdminEmail = () => {
    setSuperAdminProfileSummary((previous) => ({ ...previous, email: superAdminEmailInput }));
    setEditSuperAdminEmail(false);
  };

  /**
   * Save the edited super admin phone number
   * TODO: call the real update-profile API once available; currently updates local state only
   */
  const saveSuperAdminPhone = () => {
    setSuperAdminProfileSummary((previous) => ({ ...previous, phone: superAdminPhoneInput }));
    setEditSuperAdminPhone(false);
  };

  /**
   * Open the super admin profile image upload modal
   */
  const openProfileImageModal = () => {
    setIsProfileImageModalOpen(true);
  };

  /**
   * Close the profile image modal and discard any unsaved selection
   */
  const closeProfileImageModal = () => {
    if (profileImagePreviewUrl) {
      URL.revokeObjectURL(profileImagePreviewUrl);
    }
    setProfileImageFile(null);
    setProfileImagePreviewUrl(null);
    setIsProfileImageModalOpen(false);
  };

  /**
   * Validate a selected profile image file and stage it for preview
   * @param {React.ChangeEvent<HTMLInputElement>} event_ - The file input change event
   */
  const handleProfileImageSelect = (event_: React.ChangeEvent<HTMLInputElement>) => {
    const file = event_.target.files ? event_.target.files[0] : null;
    if (!file) return;

    const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];
    const maxSizeBytes = 1 * 1024 * 1024; // 1MB

    if (!allowedTypes.includes(file.type)) {
      dispatch(
        setNotificationMessage({
          status: true,
          message: t('invalidFileType', 'Only JPG and PNG files are allowed.'),
          type: 'error',
        }),
      );
      return;
    }

    if (file.size > maxSizeBytes) {
      dispatch(
        setNotificationMessage({
          status: true,
          message: t('invalidFileSize', 'File must be smaller than 1MB.'),
          type: 'error',
        }),
      );
      return;
    }

    if (profileImagePreviewUrl) {
      URL.revokeObjectURL(profileImagePreviewUrl);
    }
    setProfileImageFile(file);
    setProfileImagePreviewUrl(URL.createObjectURL(file));
    // eslint-disable-next-line no-param-reassign
    event_.target.value = '';
  };

  /**
   * Discard the currently staged profile image selection
   */
  const handleRemoveStagedProfileImage = () => {
    if (profileImagePreviewUrl) {
      URL.revokeObjectURL(profileImagePreviewUrl);
    }
    setProfileImageFile(null);
    setProfileImagePreviewUrl(null);
  };

  /**
   * Upload the staged profile image and update the header avatar on success
   */
  const handleSubmitProfileImage = async () => {
    if (!profileImageFile) return;
    setIsUploadingProfileImage(true);

    const formData = new FormData();
    formData.append('profileImage', profileImageFile);

    try {
      await dashboardApi.uploadCPOProfileImage(formData);
      setSuperAdminProfileImage(profileImagePreviewUrl);
      setProfileImageFile(null);
      setProfileImagePreviewUrl(null);
      setIsProfileImageModalOpen(false);
      setIsProfileImageSuccessModalOpen(true);
    } catch (error: any) {
      dispatch(
        setNotificationMessage({
          status: true,
          message:
            error?.response?.data?.message ||
            error?.message ||
            t('failedToUpdateProfileImage', 'Failed to update profile image.'),
          type: 'error',
        }),
      );
    } finally {
      setIsUploadingProfileImage(false);
    }
  };

  // /**
  //  * Light and Darkness function
  //  * @param data mode string
  //  */
  // const lightDarkness = (data: string) => {
  //   console.log(data);
  //   setDropdownOpen(false);
  // };

  // const headerList1 = [
  //   {
  //     icon: Brightness,
  //     active: true,
  //     key: 'light',
  //     function: lightDarkness,
  //     allow: false,
  //   },
  //   {
  //     icon: Darkness,
  //     active: false,
  //     key: 'dark',
  //     function: lightDarkness,
  //     allow: false,
  //   },
  //   {
  //     icon: Desktop,
  //     active: false,
  //     key: 'desk',
  //     function: lightDarkness,
  //     allow: false,
  //   },
  // ];

  /**
   * Profile click functionality
   */
  const myProfile = () => {
    setDropdownOpen(false);
    navigate('./profile');
  };

  /**
   * Navigate to settings page
   */
  const handleRoute = () => {
    navigate('/ev-admin/settings');
  };

  // const headerList2 = [
  //   {
  //     label: t('myProfile'),
  //     addClass: '',
  //     function: myProfile,
  //     allow: true,
  //   },
  //   {
  //     label: t('settings'),
  //     addClass: '',
  //     function: handleRoute,
  //     allow: true,
  //   },
  // ];

  const headerList3 = [
    {
      label: t('myProfile'),
      addClass: '',
      function: myProfile,
      allow: true,
    },
    {
      label: t('settings'),
      addClass: '',
      function: handleRoute,
      allow: true,
    },
  ];
  /**
   * Handle the close the drop down function
   * @param {any} event mouse event
   */
  const handleClickOutside = (event: MouseEvent) => {
    if (reference.current && !reference.current.contains(event.target as Node)) {
      setDropdownOpen(false);
      setDropdownNotification(false);
    }
  };

  /**
   * Function to switch the tab
   * @param key
   */
  // const handleClickToggle = (key: string) => {
  //   setChartToggle((previousTab) =>
  //     previousTab.map((tab) => ({ ...tab, isActive: tab.key === key })),
  //   );
  //   dispatch(updateChargerType(key));
  // };

  const handleDashboardChange = React.useCallback(
    (id: string) => {
      dispatch(setSelectedDashboardId(id));
    },
    [dispatch],
  );

  const allDashboards = defaultDashboard ? [defaultDashboard, ...dashboards] : [...dashboards];

  const tabOptions = React.useMemo(
    () =>
      allDashboards
        .filter((item: any) => item?.showAsTab)
        .map((item: any) => ({
          label:
            item?.id === 'default' || item?.name === 'Default Dashboard'
              ? t('defaultDashboard', { defaultValue: 'Default Dashboard' })
              : item?.name,
          value: item?.id,
        })),
    [allDashboards, t],
  );

  useEffect(() => {
    if (portalType === PortalType.PARTNER) {
      dispatch(fetchCurrentFacilityTagsList());
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (!sessionUser.id && portalType === PortalType.PARTNER) {
      const accessToken = getLocalStorageItem('ev-access-token');
      const decodedAccessToken = decodeJWT(accessToken || '');
      dispatch(fetchSessionUser(decodedAccessToken?.sub || '')); // sub -> userId in decoded token
    }
  }, []);

  useEffect(() => {
    /**
     * Fetch CPO user profile details on load
     * @returns {Promise<void>} Resolves when profile is fetched
     */
    const fetchCPOProfile = async (): Promise<void> => {
      if (portalType !== PortalType.PARTNER) {
        try {
          const response = await dashboardApi.getCPOUserProfile();
          const userData = response?.data || response;
          setCpoUserData(userData);
          const imgUrl =
            typeof userData?.profileImage === 'string'
              ? userData?.profileImage
              : userData?.profileImage?.signedUrl;
          if (imgUrl) {
            setSuperAdminProfileImage(imgUrl);
          }
          setSuperAdminProfileSummary({
            totalPartners: userData?.partnerCount || 0,
            totalStations: userData?.stationCount || 0,
            totalDevices: userData?.deviceCount || 0,
            email: userData?.email || '',
            phone: userData?.phone || userData?.phoneNumber || '',
          });
        } catch (error) {
          console.error('Error fetching CPO user profile:', error);
        }
      }
    };

    fetchCPOProfile();
  }, [portalType]);

  return (
    <div className={`admin-header-warp ${i18n.language === 'ar' ? 'rtl' : ''}`}>
      <div className="admin-header-content">
        {dashboard && (
          <TabToggle
            tabs={tabOptions}
            defaultTab={selectedDashboardId}
            onChange={handleDashboardChange}
            isLabelValue
          />
        )}
        <div className="admin-header-center">
          <div className="header-image">
            {/* <img src={brandImage.logo} alt="logo" /> */}
            <h3>{title}</h3>
            {count !== undefined && count !== null && (
              <div className="title-count-badge">
                {icon || <TrendUp />}
                <span>{count}</span>
              </div>
            )}
          </div>
        </div>
        <div className="admin-header-right">
          <div className="item">
            {notification && (
              <div
                className="notification"
                onClick={() => setDropdownNotification(true)}
                role="presentation">
                <Notification />
                <div className="tag tag-danger">3</div>
              </div>
            )}

            {dropdownNotification && (
              <div className="dropdown-notification" ref={reference}>
                <div className="dropdown-layout">asfdas</div>
              </div>
            )}
          </div>
          <div className="item theme-toggle-item item">
            <button
              type="button"
              className="theme-toggle-btn"
              onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
              style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '8px',
                color: 'var(--text-color)',
                borderRadius: '50%',
                transition: 'background-color 0.2s',
              }}
              title={theme === 'dark' ? 'Switch to Light Mode' : 'Switch to Dark Mode'}>
              {theme === 'dark' ? (
                <Brightness style={{ width: '20px', height: '20px', fill: 'var(--text-color)' }} />
              ) : (
                <Darkness style={{ width: '20px', height: '20px', fill: 'var(--text-color)' }} />
              )}
            </button>
          </div>
          <div className="item language-selector">
            <LanguageSelector
              isCollapsed
              direction="down"
              allowedLanguages={
                portalType === PortalType.PARTNER ? (sessionUser as any)?.languages : cpoUserData?.languages
              }
            />
          </div>
          {portalType !== PortalType.PARTNER && (
            <div className="item">
              <div className="profile" ref={reference}>
                <div className="item profile-image">
                  <img src={superAdminProfileImage || profile} alt="profile" />
                </div>
                <div className="item profile-details" onClick={dropdown} role="presentation">
                  <div className="profile-name">{t('superAdmin')}</div>
                  <div className="profile-dropdown-icon">
                    <Downarrow className={dropdownOpen ? 'rotate-180' : ''} />
                  </div>
                </div>
                {dropdownOpen && (
                  <div className="dropdown-content">
                    <div className="dropdown-layout admin-profile-card">
                      <div className="admin-profile-card-header">
                        <div
                          className="admin-profile-card-image profile-image profile-image-upload-trigger"
                          role="presentation"
                          onClick={openProfileImageModal}>
                          <img src={superAdminProfileImage || profile} alt="profile" />
                          <div className="profile-image-hover-overlay">
                            <UploadIcon />
                          </div>
                        </div>
                        <div className="admin-profile-card-title">{t('superAdmin')}</div>
                        <button
                          type="button"
                          className="admin-profile-card-reset-password"
                          onClick={handleOpenResetPassword}>
                          {translateProfile('changePassword')}
                        </button>
                      </div>
                      <div className="admin-profile-card-row">
                        <div className="admin-profile-card-field">
                          <TimeZoneSelector
                            initialTimeZone={
                              portalType === PortalType.PARTNER
                                ? (sessionUser as any)?.timezone ||
                                  (sessionUser as any)?.time_zone ||
                                  (sessionUser as any)?.timeZone
                                : cpoUserData?.timezone ||
                                  cpoUserData?.time_zone ||
                                  cpoUserData?.timeZone
                            }
                          />
                        </div>
                        <div className="admin-profile-card-field">
                          <LanguageSelector
                            isCollapsed={false}
                            direction="down"
                            allowedLanguages={
                              portalType === PortalType.PARTNER
                                ? (sessionUser as any)?.languages
                                : cpoUserData?.languages
                            }
                          />
                        </div>
                      </div>
                      <div className="admin-profile-card-stats">
                        <div className="admin-profile-card-stats-header">
                          <div className="facility-icon">
                            <brandIcons.facilityIcon />
                          </div>
                          <p>{t('facility')}</p>
                        </div>
                        <div className="admin-profile-card-stats-grid">
                          <div className="facility-count">
                            <p>{t('totalPartners')}</p>
                            <span>{superAdminProfileSummary.totalPartners}</span>
                          </div>
                          <div className="facility-count">
                            <p>{t('totalStations')}</p>
                            <span>{superAdminProfileSummary.totalStations}</span>
                          </div>
                          <div className="facility-count">
                            <p>{t('totalDevices')}</p>
                            <span>{superAdminProfileSummary.totalDevices}</span>
                          </div>
                        </div>
                      </div>
                      <div className="admin-profile-card-contact">
                        <div className="admin-profile-card-contact-header">
                          <div className="contact-icon">
                            <brandIcons.contactIcon />
                          </div>
                          <span>{t('contact')}</span>
                        </div>
                        <div className="admin-profile-card-contact-content">
                          {editSuperAdminEmail ? (
                            <div className="admin-profile-card-contact-edit">
                              <CustomInput
                                type="email"
                                name="email"
                                placeholder={t('enterEmail')}
                                value={superAdminEmailInput}
                                onChangeValue={handleSuperAdminContactInputChange}
                              />
                              <div className="admin-profile-card-contact-edit-actions">
                                <span
                                  className="save-icon"
                                  role="presentation"
                                  onClick={saveSuperAdminEmail}>
                                  <Tick />
                                </span>
                                <span
                                  className="cancel-icon"
                                  role="presentation"
                                  onClick={() => setEditSuperAdminEmail(false)}>
                                  <Close />
                                </span>
                              </div>
                            </div>
                          ) : (
                            <div className="each-contact-content">
                              <p>{t('email')}:</p>
                              <span>{superAdminProfileSummary.email}</span>
                              {superAdminProfileSummary.email === '123456' && (
                                <ProfileEdit
                                  className="icons"
                                  onClick={toggleSuperAdminEmailEdit}
                                  role="presentation"
                                />
                              )}
                            </div>
                          )}
                          {editSuperAdminPhone ? (
                            <div className="admin-profile-card-contact-edit">
                              <CustomInput
                                type="text"
                                name="phone"
                                placeholder={t('enterPhoneNumber')}
                                value={superAdminPhoneInput}
                                onChangeValue={handleSuperAdminContactInputChange}
                              />
                              <div className="admin-profile-card-contact-edit-actions">
                                <span
                                  className="save-icon"
                                  role="presentation"
                                  onClick={saveSuperAdminPhone}>
                                  <Tick />
                                </span>
                                <span
                                  className="cancel-icon"
                                  role="presentation"
                                  onClick={() => setEditSuperAdminPhone(false)}>
                                  <Close />
                                </span>
                              </div>
                            </div>
                          ) : (
                            <div className="each-contact-content">
                              <p>{t('phone')}:</p>
                              <span>{superAdminProfileSummary.phone}</span>
                              {superAdminProfileSummary.phone === '123456' && (
                                <ProfileEdit
                                  className="icons"
                                  onClick={toggleSuperAdminPhoneEdit}
                                  role="presentation"
                                />
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}

          {portalType === PortalType.PARTNER && (
            <>
              {portalType !== PortalType.PARTNER && (
                <div className="item">
                  <div className="profile">
                    <div
                      className="item profile-details"
                      onClick={dropDownFacility}
                      role="presentation">
                      {currentFacilityTagsList.map((value) => {
                        return (
                          <div className="profile-name" role="presentation">
                            {value.isSelected && t(value.facilityTagName)}
                          </div>
                        );
                      })}
                      <div className="profile-dropdown-icon">
                        <Downarrow className={dropdownFacilityOpen ? 'rotate-180' : ''} />
                      </div>
                    </div>
                    {dropdownFacilityOpen && (
                      <div className="dropdown-content" ref={reference}>
                        <div className="dropdown-layout">
                          <div className="dropdown-facility-tag-body">
                            <div className="body-list">
                              {currentFacilityTagsList.map((value) => (
                                <div
                                  className={`${value.isSelected ? 'text-success' : 'item'}`}
                                  onClick={() =>
                                    filterByFacility({
                                      facilityTagName: value.facilityTagName,
                                    })
                                  }
                                  role="presentation">
                                  <div>{t(value.facilityTagName)}</div>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}
              <div className="item">
                <div className="profile">
                  <div className="item profile-image">
                    <img src={sessionUser?.profileImage?.signedUrl || profile} alt="profile" />
                  </div>
                  <div className="item profile-details" onClick={dropdown} role="presentation">
                    <div className="profile-name">{sessionUser?.name}</div>
                    <div className="profile-dropdown-icon">
                      <Downarrow className={dropdownOpen ? 'rotate-180' : ''} />
                    </div>
                  </div>
                  {dropdownOpen && (
                    <div className="dropdown-content" ref={reference}>
                      <div className="dropdown-layout">
                        <div className="dropdown-body">
                          <div className="body-list">
                            {headerList3.map(
                              (value) =>
                                value.allow && (
                                  <div
                                    className="item"
                                    onClick={value.function}
                                    role="presentation">
                                    <div className={value.addClass}>{value.label}</div>
                                    <div className="list-icon">
                                      <Downarrow />
                                    </div>
                                  </div>
                                ),
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </>
          )}
        </div>
      </div>

      <ModalBox
        open={isProfileImageModalOpen}
        title={t('updateProfileImage', 'Update Profile Image')}
        closeModal={closeProfileImageModal}
        header
        position="center"
        content={
          <div className="profile-image-modal-body">
            <p className="modal-subtitle">
              {t(
                'profileImageUploadDesc',
                'Upload a photo to personalize your profile. JPG or PNG, up to 5MB.',
              )}
            </p>

            {profileImagePreviewUrl ? (
              <div className="profile-image-preview-wrapper">
                <div className="profile-image-preview-circle">
                  <img src={profileImagePreviewUrl} alt={t('preview', 'Preview')} />
                </div>
                <button
                  type="button"
                  className="remove-image-overlay-btn"
                  onClick={handleRemoveStagedProfileImage}>
                  <span>&times;</span>
                </button>
              </div>
            ) : (
              <label className="profile-image-add-box-btn" htmlFor="header-profile-image-input">
                <input
                  id="header-profile-image-input"
                  type="file"
                  accept="image/*"
                  style={{ display: 'none' }}
                  onChange={handleProfileImageSelect}
                />
                <div className="dashed-box-content">
                  <span className="plus-icon">+</span>
                  <span className="box-title">{t('upload', 'Upload')}</span>
                  <span className="box-desc">{t('fileRequirements', 'JPG, PNG up to 1MB')}</span>
                </div>
              </label>
            )}

            <div className="modal-actions-container">
              <div className="line" />
              <div className="button-wrap">
                <MyButton
                  label={t('cancel')}
                  buttonType="primary-outline"
                  onClickFunc={closeProfileImageModal}
                />
                <MyButton
                  label={isUploadingProfileImage ? t('saving', 'Saving...') : t('submit')}
                  buttonType="submit"
                  onClickFunc={handleSubmitProfileImage}
                  disableButton={!profileImageFile || isUploadingProfileImage}
                  loading={isUploadingProfileImage}
                />
              </div>
            </div>
          </div>
        }
      />

      <ModalBox
        open={isProfileImageSuccessModalOpen}
        title={null}
        content={
          <SuccessNotification
            title={t('profileImageUpdatedSuccessfully', 'Profile image updated successfully.')}
            description={t(
              'profileImageUpdatedSuccessfullyDesc',
              'Your profile picture has been updated.',
            )}
            notificationCloseTimer={3000}
            onNotificationClose={() => setIsProfileImageSuccessModalOpen(false)}
          />
        }
        closeModal={() => setIsProfileImageSuccessModalOpen(false)}
        notification
        header={false}
      />
      <ResetPasswordModal
        open={resetPasswordModalOpen}
        onClose={handleCloseResetPassword}
      />
    </div>
  );
}

export default Header;
